import { Link } from "@clockwise/design-system";
import {
  PageLayout,
  PageLayoutContent,
  PageLayoutStripe,
} from "@clockwise/web-commons/src/ui/page-layout/PageLayout";
import React, { useEffect } from "react";
import Helmet from "react-helmet";
import AccountPreferences from "../components/account-preferences/AccountPreferences";
import { FlexibleMeetingsBanner } from "../components/flexible-meetings-banner";
import { FlexibleMeetingsCallout } from "../components/flexible-meetings-callout";
import { PageEvents, page } from "../util/analytics.util";

const AccountPreferencesPage = () => {
  useEffect(() => {
    page(PageEvents.ACCOUNT_PREFERENCES_PAGE);
  }, []);

  return (
    <>
      <Helmet>
        <title>Your ideal day · Clockwise</title>
      </Helmet>

      <PageLayout
        title="What's in your ideal day?"
        callout={<FlexibleMeetingsCallout />}
        description={
          <>
            Clockwise moves the events you mark as flexible to help you have the best possible day —
            whatever that means to you. The more preferences you set, the more we can help!{" "}
            <Link href="https://support.getclockwise.com/hc/en-us/articles/12443682993172-The-Clockwise-web-experience#heading-3">
              Learn more
            </Link>
          </>
        }
      >
        <PageLayoutContent>
          <AccountPreferences />
        </PageLayoutContent>
        <PageLayoutStripe sentiment="info">
          <PageLayoutContent>
            <FlexibleMeetingsBanner />
          </PageLayoutContent>
        </PageLayoutStripe>
      </PageLayout>
    </>
  );
};

export default AccountPreferencesPage;
